import axios from "axios";
import {
  AvailabilityApiFactory,
  DocumentSigningApiFactory,
  ElementManagerApiFactory,
  EquipmentApiFactory,
  EquipmentHistoryUserApiApiFactory,
  EventsApiFactory,
  MemberApiFactory,
  MemberImportApiFactory,
  ObjectApiFactory,
  ProgressionManagerApiFactory,
  RuleConfigurationsApiFactory,
  RuleEvaluatorApiFactory,
  RuleManagerApiFactory,
  ScheduleApiFactory,
  UploadApiFactory,
} from "@radianse/services";

import { ConnectorApiFactory } from "@radianse/connectors-api";
import { TenantDetailsApiFactory } from "@radianse/customers-api";
import { ScheduleApiFactory as NewScheduleApiFactory } from "@radianse/schedule-api";

import {
  EventsApiFactory as NewEventsApiFactory,
  ServicesApiFactory,
  EquipmentApiFactory as NewEquipmentApiFactory,
  ElementManagerApiFactory as NewElementManagerApiFactory,
} from "@radianse/elements-api";

export const _basePath = process.env.BASE_PATH || "";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: window["_env"].API_URL,
});

export const availApiConfig = {
  basePath: window["_env"].API_URL + "/app/availability",
  _basePath,
  instance,
};

export const deviceHistoryApiConfig = {
  basePath: window["_env"].API_URL + "/app/devicehistory",
  _basePath,
  instance,
};

export const documentsApiConfig = {
  basePath: window["_env"].API_URL + "/app/documents",
  _basePath,
  instance,
};

export const elementsApiConfig = {
  basePath: window["_env"].API_URL + "/app/elements",
  _basePath,
  instance,
};

export const memberImportApiConfig = {
  basePath: window["_env"].API_URL + "/app/memberimport",
  _basePath,
  instance,
};

export const progressionApiConfig = {
  basePath: window["_env"].API_URL + "/app/progression",
  _basePath,
  instance,
};

export const ruleApiConfig = {
  basePath: window["_env"].API_URL + "/App/Rules",
  _basePath,
  instance,
};

export const scheduleApiConfig = {
  basePath: window["_env"].API_URL + "/app/schedule",
  _basePath,
  instance,
};

export const connectorApiConfig = {
  basePath: window["_env"].API_URL + "/app/connectors",
  _basePath,
  instance,
  isJsonMime: () => true,
};

export const customersApiConfig = {
  basePath: window["_env"].API_URL + "/app/customers",
  _basePath,
  instance,
};

export const connectorServiceApi = ConnectorApiFactory(connectorApiConfig);

export const availApiClient = AvailabilityApiFactory(availApiConfig);
export const documentSigningApiClient =
  DocumentSigningApiFactory(documentsApiConfig);
export const elementsApiClient = ObjectApiFactory(elementsApiConfig);
export const elementManagerApiClient =
  ElementManagerApiFactory(elementsApiConfig);
export const newElementManagerApiClient =
  NewElementManagerApiFactory(elementsApiConfig);
export const equipmentApiClient = EquipmentApiFactory(elementsApiConfig);
export const newEquipmentApiClient = NewEquipmentApiFactory(elementsApiConfig);
export const equipmentHistoryApiClient = EquipmentHistoryUserApiApiFactory(
  deviceHistoryApiConfig
);
export const eventsApiClient = EventsApiFactory(elementsApiConfig);
export const newEventsApiClient = NewEventsApiFactory(elementsApiConfig);
export const memberApiClient = MemberApiFactory(elementsApiConfig);
export const memberImportApiClient = MemberImportApiFactory(
  memberImportApiConfig
);
export const progressionManagerApiClient =
  ProgressionManagerApiFactory(progressionApiConfig);
export const ruleConfigurationsApiClient =
  RuleConfigurationsApiFactory(ruleApiConfig);
export const ruleEvaluatorApiClient = RuleEvaluatorApiFactory(ruleApiConfig);
export const ruleManagerApiClient = RuleManagerApiFactory(ruleApiConfig);
export const scheduleApiClient = ScheduleApiFactory(scheduleApiConfig);
export const newScheduleApiClient = NewScheduleApiFactory(scheduleApiConfig);
export const servicesApiClient = ServicesApiFactory(elementsApiConfig);
export const uploadApiClient = UploadApiFactory(documentsApiConfig);

export const tenantDetailApiClient =
  TenantDetailsApiFactory(customersApiConfig);
